import { useMerchant } from "@auth";

const BRANCH_SCOPED_MERCHANTS = ["a1c62358-58e0-4e63-9dd0-fcc5a0378996"];

export const useIsBranchScoped = () => {
  const { merchant, memberships } = useMerchant();
  const userBranchId = memberships?.find((m) => String(m.merchantId) === String(merchant?.id))?.branchId ?? null;
  return !!userBranchId && BRANCH_SCOPED_MERCHANTS.includes(String(merchant?.id));
};
